import $ from "jquery";

let modalContainer;
let modalComboUrl;
let modalProductUrl;
let modalContainerHtml;

$(function () {
    modalContainer = $('#modalAddToProductCart');
    modalComboUrl = modalContainer.attr('data-combo-url');
    modalProductUrl = modalContainer.attr('data-url');
    modalContainerHtml = modalContainer.find('.container-modal');
})

$(document).off('submit', '.form-add-to-cart').on('submit', '.form-add-to-cart', function (e) {
    e.preventDefault();
    const form = $(this);
    if (form.hasClass('js-send')) {
        return false;
    }

    form.addClass('js-send');
    form.find('.has-error').removeClass('has-error');

    $.ajax({
        url: form.attr('action'), type: "POST", data: form.serialize(), dataType: 'json',
    }).done(function (response) {
        modalContainer.modal('hide');

        $('.js-cart-total').html(response.total);

        const switcher = $('.delivery-switcher-wrap ul.delivery-switcher');
        const citySwitcher = $('.change-type-notice.js-switcher');
        const mDdSwitcher = $('.md-dropdown-delivery.js-switcher');
        if (!switcher.hasClass('with-notice')) {
            switcher.addClass('with-notice')
        }

        if (!mDdSwitcher.hasClass('with-notice')) {
            mDdSwitcher.addClass('js-without-notice')
            mDdSwitcher.addClass('with-notice')
        }

        if (!citySwitcher.hasClass('with-notice')) {
            citySwitcher.addClass('js-without-notice')
            citySwitcher.addClass('with-notice')
        }

        const productId = form.find("input[name='product_id']").val();
        const productWrap = $('.js-product-' + productId);

        if (!productWrap.hasClass('cart-border-active')) {
            productWrap.addClass('cart-border-active');
        }

        addToCartEventGA(response.gaEventData);

        if (response.refresh) document.location.reload();

    }).fail(function (jqXHR, textStatus) {
        const response = jqXHR.responseJSON;
        if (typeof response !== 'undefined' && typeof response.errors !== 'undefined') {
            $.each(response.errors, function (index, value) {
                $('.' + index).addClass('has-error');
            });
        } else {
            console.log(jqXHR)
        }

        form.removeClass('js-send');
    });
});

function addToCartEventGA(data) {
    gtag("event", "add_to_cart", {
        currency: "MDL", value: data.total, items: [{
            item_id: data.id,
            item_name: data.name,
            currency: "MDL",
            index: 0,
            item_category: data.category,
            item_list_id: "products",
            item_list_name: "Web category list",
            item_variant: data.item_variant,
            location_id: data.location_id,
            price: data.price,
            quantity: data.quantity
        }]
    });
}

$(document).on('click', '.js-combo-init', function (el) {
    el.preventDefault();
    el.stopPropagation();

    loadModal(el.currentTarget.dataset.combo, 'combo');
})

$(document).on('click', '.js-product-form', function (el) {
    el.preventDefault();
    el.stopPropagation();

    loadModal(el.currentTarget.dataset.product, false, el.currentTarget.dataset.reload);
})

$('.js-product-modal .modal-content').on('scroll', function (el) {
    if (el.target.scrollTop > 1) {
        $('.main-product').addClass('scrolled')
    } else {
        $('.main-product').removeClass('scrolled')
    }
});

function loadModal(id, type, reload) {
    $.ajax({
        url: type === 'combo' ? modalComboUrl : modalProductUrl, type: "GET", data: {
            id: id, reload
        }, dataType: 'json',
    }).done(function (response) {
        if (response.status === true) {
            modalContainerHtml.hide().html(response.form).fadeIn()
        }

        setTimeout(function () {
            const bodyWidth = window.innerWidth;
            if (bodyWidth > 991) {
                const heightOffset = Math.round(modalContainerHtml.find('.main-product').height() + 50) - 35;

                modalContainerHtml.find('.add-cart-container').css('paddingTop', heightOffset)
            } else {
                modalContainerHtml.find('.add-cart-container').css('paddingTop', 0)
            }
        }, 200)

        const currentModal = $('.modal.show');
        if (currentModal) {
            modalContainer.modal('show');
        } else {
            if (response.form) {
                currentModal.on('hidden.bs.modal', function () {
                    modalContainer.modal('show');
                    currentModal.unbind();
                });
            }
            currentModal.modal('hide');
        }


    }).fail(function (jqXHR, textStatus) {
        $('.modal.show').modal('hide');

        alert("Request failed: " + textStatus);
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/comboProduct.js